<template>
    <MainCard title="Compartilhar" subtitle="Compartilhe seu assistente utilizando as informações abaixo.">
        <div class="tab-content d-flex justify-space-between align-start">
            <div class="tab-content-text d-flex flex-column ga-8 px-8">
                <div class="share d-flex flex-column ga-6">
                    <h2 class="title-medium">Compartilhe o link público do assistente:</h2>
                    <div class="share-content d-flex flex-column ga-4">
                        <rb-input v-model="shareLinkInput" readonly width="800px" append-inner-icon="mdi-open-in-new" @click:append-inner="openLink"></rb-input>
                    </div>
                </div>
            </div>
        </div>
    </MainCard>
</template>

<script setup>
import { onMounted, ref,} from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();
import MainCard from '@/ai_studio/components/layout/MainCard.vue';
const assistentKey = route.params.key;
const shareLinkInput = ref('');

const openLink = () => {
    window.open(shareLinkInput.value, '_blank')
}

onMounted(()=>{
    shareLinkInput.value = `${window.location.origin}/api/assistents/chat?key=${assistentKey}&user_code=&idContato=&idRegistro=&codRegistro=`
})
</script>


<style lang="scss" scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss'
</style>